import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Panza plana a la mañana. Globo a la noche.', 'Comés verdura y te inflás más que si comieras una milanesa.', 'Tu médico dijo "es estrés" y ningún tratamiento funcionó de verdad.', 'Probaste probióticos, infusiones y dietas. El problema vuelve.', 'Ya no salís a cenar tranquila porque no sabés qué te va a caer mal.', 'Llevás meses o años buscando respuestas. Cada solución fue temporal.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-155">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-156" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-159">
            <h2 className="md:text-5xl font-bold mb-6 font-[Poppins,_sans-serif] text-[24px]" data-id="element-160">
              ¿Cuántos años más vas a vivir con esta panza?
            </h2>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-161">
              Sos inteligente. Comés sano. Buscás soluciones.
            </p>
            <p className="text-gray-300 mb-4 text-[19px]" data-id="element-162">
              Pero nadie te dio el mapa correcto para tu intestino.
            </p>
            <p className="text-xl text-brand-light font-medium" data-id="element-163">
              No es la edad. No es la menopausia. No es falta de voluntad. Es
              falta de un sistema.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-164">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-165">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-166" />
                <p className="text-lg text-gray-200" data-id="element-167">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="text-center" data-id="element-168">
            <h3 className="text-xl md:text-3xl font-bold text-brand-gold italic font-[Inter,_sans-serif] leading-snug" data-id="element-169">
              Tu problema no es lo que comés, es la FERMENTACIÓN POR
              ESTANCAMIENTO.
            </h3>
            <p className="text-gray-200 text-base md:text-lg mt-4 max-w-3xl mx-auto leading-relaxed not-italic" data-id="element-170">
              Tu intestino procesa alimentos sanos a la velocidad equivocada.
              Necesitás un sistema que resetee ese ritmo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}